export const OTP_RESEND_TIMEOUT_MILLISECONDS = 120000
export const ENCRYPTION_PASSPHRASE = 'ticketsms'

export const RECAPTCHA_TOKEN = 'recaptcha-token'
export const RECAPTCHA_ACTION = 'recaptcha-action'
export const RECAPTCHA_HOST = 'recaptcha-host'

export const RECAPTCHA_OTP_ACTION = 'shop/auth/otp'
